// Types owned by @kinnet-studio/pattern — re-exported so downstream code
// imports them from this module (mirrors tbc-types.ts / guide-types.ts).
export type { VerticalLinkId, VerticalLink, VerticalNodeRef } from '@kinnet-studio/pattern';

import type { VerticalLinkId, VerticalNodeRef } from '@kinnet-studio/pattern';

/** Mint a stable `VerticalLinkId`. UUID-based, matching newBaseId/newTopId. */
export function newVerticalLinkId(): VerticalLinkId {
    return `vlink-${crypto.randomUUID()}`;
}

/** Stable string key for a node ref — for Set/Map membership and equality. */
export function nodeRefKey(ref: VerticalNodeRef): string {
    return `${ref.kind}:${ref.id}`;
}

/** Structural equality for two node refs. */
export function nodeRefEquals(a: VerticalNodeRef, b: VerticalNodeRef): boolean {
    return a.kind === b.kind && a.id === b.id;
}
